import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "team-members h-100" }
const _hoisted_2 = { class: "team-info-tab-row row nav-pills d-flex" }
const _hoisted_3 = { class: "flex-fill d-flex justify-content-end" }
const _hoisted_4 = { class: "team-info-body row" }
const _hoisted_5 = { class: "w-100" }
const _hoisted_6 = {
  key: 0,
  id: "member-list",
  class: "list-group"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_member_item = _resolveComponent("member-item")!
  const _component_candidate_item = _resolveComponent("candidate-item")!
  const _component_invite_item = _resolveComponent("invite-item")!
  const _component_TeamInviteModal = _resolveComponent("TeamInviteModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "header row" }, [
      _createElementVNode("h4", { class: "invisible" }, "Members")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        class: "nav-link",
        href: "#",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.$parent.showTeamProjects && _ctx.$parent.showTeamProjects(...args)))
      }, "Projects"),
      _cache[1] || (_cache[1] = _createElementVNode("a", {
        class: "nav-link active",
        href: "#"
      }, "People", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          "data-toggle": "modal",
          "data-target": "#modal-new-invite",
          class: _normalizeClass([{'hide': _ctx.hasCard()}, "btn btn-attention btn-new-item pull-right btn-invite"])
        }, " New Member ", 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_ctx._team)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.participants, (p) => {
                return (_openBlock(), _createElementBlock("div", _mergeProps({ class: "list-group-item list-group-item-action" }, { ref_for: true }, {'data-id': p.uid}), [
                  _createVNode(_component_member_item, {
                    member: p,
                    team: _ctx._team,
                    removeButton: ""
                  }, null, 8, ["member", "team"])
                ], 16))
              }), 256)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.candidates, (c) => {
                return (_openBlock(), _createElementBlock("div", _mergeProps({ class: "list-group-item list-group-item-action" }, { ref_for: true }, {'data-id': c.email}), [
                  _createVNode(_component_candidate_item, {
                    candidate: c,
                    team: _ctx._team,
                    onInvite: ($event: any) => (_ctx.setInvitationData(c))
                  }, null, 8, ["candidate", "team", "onInvite"])
                ], 16))
              }), 256)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invites, (ivt) => {
                return (_openBlock(), _createElementBlock("div", _mergeProps({ class: "list-group-item" }, { ref_for: true }, {'data-id': ivt.code}), [
                  _createVNode(_component_invite_item, {
                    invite: ivt,
                    team: _ctx._team
                  }, null, 8, ["invite", "team"])
                ], 16))
              }), 256))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass([{'d-none': !_ctx.hasCard()}, "w-100"])
      }, [...(_cache[2] || (_cache[2] = [
        _createStaticVNode("<div class=\"justify-content-center\"><div class=\"text-center\"><i class=\"fa fa-5x fa-user-plus mt-5 mb-2\"></i><br><button type=\"button\" class=\"btn btn-attention btn-new-item\" data-toggle=\"modal\" data-target=\"#modal-new-invite\"> Invite New Member </button></div></div><div class=\"mt-3 justify-content-center\"><p class=\"text-muted text-center\">You can invite as many people as you wish. You are charged for active team members only.<br><a href=\"https://help.ganttproject.biz/t/what-is-a-team-in-ganttproject-cloud\" target=\"_blank\">Learn more</a></p></div>", 2)
      ]))], 2)
    ]),
    (_ctx._team)
      ? (_openBlock(), _createBlock(_component_TeamInviteModal, {
          key: 0,
          team: _ctx._team,
          "dashboard-refresh": _ctx.onInviteCreated,
          ref: "inviteModal"
        }, null, 8, ["team", "dashboard-refresh"]))
      : _createCommentVNode("", true)
  ]))
}